import { IconName } from 'src/components/ui/Icon/Icon';
import { MimeType } from './services/utility';

export const socialIcons = [
  {
    icon: 'facebook' as IconName,
    href: 'https://www.facebook.com/WeShip-Fulfillment-555228558238940',
  },
  {
    icon: 'linkedin' as IconName,
    href: 'https://at.linkedin.com/company/weship',
  },
  {
    icon: 'x' as IconName,
    href: 'https://twitter.com/WS_Fulfillment',
  },
];

export const getPlaceholderImageFromMimetype = (mimetype: string) => {
  switch (mimetype) {
    case MimeType.PDF: {
      return '/assets/chat/pdf.png';
    }
    case MimeType.JPEG:
    case MimeType.PNG: {
      return '/assets/chat/image.png';
    }
    default: {
      return '/assets/chat/file.png';
    }
  }
};
